export const iconButtonStyles = {
  border: '1px solid #1976d2',
  borderRadius: '4px',
  height: '36px',
  width: '36px',
};

export const iconButtonStylesLarge = {
  border: '1px solid #1976d2',
  borderRadius: '4px',
  height: '48px',
  width: '48px',
  padding: '12px',
};